export * from "./articles/Articles.resolver"
export * from "./callToAction/CallToAction.resolver"
export * from "./cartePlus/CartePlus.resolver"
export * from "./columns/Columns.resolver"
export * from "./content/Content.resolver"
export * from "./contentWithImage/ContentWithImage.resolver"
export * from "./downloads/Downloads.resolver"
export * from "./employees/Employees.resolver"
export * from "./events/Events.resolver"
export * from "./form/Form.resolver"
export * from "./formations/Formations.resolver"
export * from "./gallery/Gallery.resolver"
export * from "./hero/Hero.resolver"
export * from "./image/Image.resolver"
export * from "./jobOffers/JobOffers.resolver"
export * from "./logoGrid/LogoGrid.resolver"
export * from "./magazine/Magazine.resolver"
export * from "./news/News.resolver"
export * from "./pageHeader/PageHeader.resolver"
export * from "./prixMinus/PrixMinusMap.resolver"
export * from "./searchPharmacy/SearchPharmacy.resolver"
export * from "./teasers/TeasersCustom.resolver"
export * from "./teasers/TeasersLatest.resolver"
export * from "./teasers/TeasersManual.resolver"
export * from "./timeline/Timeline.resolver"
export * from "./video/Video.resolver"
